import { COMPONENTS } from '../../../components/components.registry';
import { TrackAddToCartConfig } from '../../../models';

export const DEFAULT_TRACK_ADD_TO_CART_CONFIG: TrackAddToCartConfig = {
  components: {
    addToCartOnProductPage: COMPONENTS.PURE.Add2CartOnProductPage
  },
  buttonsSelector: '.add2Cart',
  resultIdUrlParamName: 'productId',
  storage: {
    result: 'add2cart-result',
    resultKeyField: 'id',
    resultTTLInMs: 60 * 1000,
    rightClickResultId: 'right-click-result'
  }
};
